import Vue from "vue";
import FillInTheBlanks from "components/Homework_bank/FillInTheBlanks_bank.vue";
import Multiselect from "components/Homework_bank/Multiselect_bank.vue";
import TrueFalse from "components/Homework_bank/TrueFalse_bank.vue";
import ShortAnswer from "components/Homework_bank/ShortAnswer_bank.vue";
import QuestionList from "components/Homework_bank/QuestionList_bank.vue";
import Synthesis from "components/Homework_bank/Synthesis_bank.vue";
export default Vue.extend({
  components: {
    Synthesis: Synthesis,
    TrueFalse: TrueFalse,
    ShortAnswer: ShortAnswer,
    QuestionList: QuestionList,
    Multiselect: Multiselect,
    FillInTheBlanks: FillInTheBlanks
  },
  data: function data() {
    return {
      // data:[],
      title: "2019/06/10 16：23：02的题库作业",
      type: "1",
      degree: "简单",
      course: "现代物流管理",
      name: "李晓帆",
      resourceType: "题库作业",
      date: "2018-09-23 15：23：12",
      number: 192,
      workImg: require("assets/images/login.png"),
      questionList: [{
        Analysis: "<p>6</p>",
        Answers: ["2", "3"],
        AnswersContent: "2；3",
        Content: "<p>4</p>",
        ContentText: "4",
        CourseId: "qpxpaieqf7xjsvtx3heghw",
        CreateDisplayName: "王涛",
        DateCreated: "2019/7/15 17:30:38",
        Difficulty: 1,
        Id: "tpagayuqrllg8bedsfwvnq",
        OrderNumber: 1,
        PaperId: "n0ssaiuqwbvpchqgs98bg",
        PaperType: 3,
        QuestionId: "1ngbaiiq9yrpxvemlkazag",
        QuestionType: 2,
        Score: "0.00",
        SelectContent: "<p>4</p>；<p>6</p>；<p>8</p>；<p>0</p>",
        Selects: ["<p>4</p>", "<p>6</p>", "<p>8</p>", "<p>0</p>"],
        analysisFiles: [],
        stemFiles: [],
        sublist: []
      }, {
        Analysis: "<p>6</p>",
        Answers: ["2", "3"],
        AnswersContent: "2；3",
        Content: "<p>4</p>",
        ContentText: "4",
        CourseId: "qpxpaieqf7xjsvtx3heghw",
        CreateDisplayName: "王涛",
        DateCreated: "2019/7/15 17:30:38",
        Difficulty: 1,
        Id: "tpagayuqrllg8bedsfwvnq",
        OrderNumber: 1,
        PaperId: "n0ssaiuqwbvpchqgs98bg",
        PaperType: 3,
        QuestionId: "1ngbaiiq9yrpxvemlkazag",
        QuestionType: 2,
        Score: "0.00",
        SelectContent: "<p>4</p>；<p>6</p>；<p>8</p>；<p>0</p>",
        Selects: ["<p>4</p>", "<p>6</p>", "<p>8</p>", "<p>0</p>"],
        analysisFiles: [],
        stemFiles: [],
        sublist: []
      }],
      topic: "大于3的",
      option: ["1", "2", "3", "4"],
      answer: 2,
      analysis: "123456789",
      selects: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"]
    };
  },
  props: {
    data: {
      type: Object,
      default: null
    },
    courseId: {
      type: String,
      default: ''
    }
  },
  methods: {
    clikBank: function clikBank() {
      this.$router.push({
        name: 'teachingDetails',
        params: {
          bookId: this.courseId
        }
      });
    },
    //获取题目类型
    getQuestionType: function getQuestionType(QuestionType) {
      if (QuestionType == 1) {
        return "单选题";
      } else if (QuestionType == 2) {
        return "多选题";
      } else if (QuestionType == 3) {
        return "判断题";
      } else if (QuestionType == 4) {
        return "填空题";
      } else if (QuestionType == 5) {
        return "简答题";
      } else {
        return "综合题";
      }
    },
    //难度显示
    changedif: function changedif(dif) {
      if (dif == 1) {
        return "简单";
      } else if (dif == 2) {
        return "一般";
      } else {
        return "较难";
      }
    }
  }
});